/**
 * Shop Layouts - Index
 * Export all shop layout components
 */

export { default as ProductCard } from './ProductCard';
export { default as GridClassicLayout } from './GridClassicLayout';
export { default as GridMasonryLayout } from './GridMasonryLayout';
export { default as MagazineLayout } from './MagazineLayout';

// Layout registry for dynamic rendering
export const layoutRegistry = {
  'grid-classic': require('./GridClassicLayout').default,
  'grid-masonry': require('./GridMasonryLayout').default,
  'magazine': require('./MagazineLayout').default,
};

// Get layout component by type
export function getLayoutComponent(layoutType) {
  return layoutRegistry[layoutType] || layoutRegistry['grid-classic'];
}
